import React, { Component } from 'react';
import { IReducerState } from '../../../states/renditionStates';
import { switchPage } from '../../../utils/api/pageControl';
import { connect } from 'react-redux';
import { RSCH_HTML_TRACKING_CONFIG } from '../../../readership/trackingConfig';
import { enterKeyPressed } from '../../../utils/general/enterKey';
import RenditionUrlGenerator from "../../../utils/api/renditionUrlGenerator";
import commonStore from '../../../store/commonStore';
import _ from 'lodash';
import { base64urlEncode } from '../../../utils/general/general';

interface IFocusListProps {
    source?: any;
    docHeaderSectionJson: any;
    isExternalUser?: boolean;
}

export class FocusList extends Component<IFocusListProps, any> {
    constructor(props: IFocusListProps) {
        super(props);
    }

    public render() {
        const { docHeaderSectionJson, isExternalUser } = this.props;
        const menuCode = commonStore.getState().commonStateReducer.menuCode;
        const environment = window.HTML_RENDITION.initialData.environment;
        let url = RenditionUrlGenerator.URL_GENERATOR.environments(environment) + '/cv2/smartlink/menu/RSCH_LANDING_PAGE?U0xfNjQ.' + btoa('urlOverride=' + encodeURIComponent('/cvr/citiresearchui/eppublic/focus_list/nam'));
        if (isExternalUser) {
            url = RenditionUrlGenerator.URL_GENERATOR.environments(environment) + "/cvr/citiresearchui/eppublic/pure/focus_list/nam";
        } else if (!_.isEmpty(menuCode) && !_.isEqual(menuCode, 'RSCH_LANDING_PAGE')) {
            url = RenditionUrlGenerator.URL_GENERATOR.environments(environment) + `/cv2/go/${menuCode}/` +base64urlEncode("__NAVIGATION_BASE64__cvr/citiresearchui/eppublic/pure/focus_list/nam");       
        }
        return (
            <React.Fragment>
                <div className="financials"
                     onClick={() => {
                        // switchPage('focusListPage');
                        window.open(url, isExternalUser ? "_self" : "_blank");
                        RSCH_HTML_TRACKING_CONFIG.trackFocusList();
                     }}
                     onKeyPress={(e) => {
                        // enterKeyPressed(e, switchPage.bind(this,'focusListPage'));
                        window.open(url, isExternalUser ? "_self" : "_blank");
                        RSCH_HTML_TRACKING_CONFIG.trackFocusList();
                     }}
                >
                    {/* <span className="icon-focus-list icon-sprite" role="img" aria-label={docHeaderSectionJson.i18n.focusList} /> */}
                    <span className='icon-svg-parent'>
                        <span className="icon-svg icon-focus-list-svg" role="img" aria-label={docHeaderSectionJson.i18n.focusList} />
                    </span>
                    <a tabIndex={0} role="link" className="x-rsch-hyperlink" aria-label={docHeaderSectionJson.i18n.focusList}>{docHeaderSectionJson.i18n.focusList}</a>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        docHeaderSectionJson: state.asyncStateReducer.docHeaderJsonData
    };
};

export default connect(mapStateToProps)(FocusList);
